// @flow

import type { VideoType } from './components/domain'

export const VIDEO_BASE_PATH = 'https://static.nrk.no/dh/videos/sporten/2019/vbm'

export function toVideoSrc (video: VideoType) {
  return {
    poster: VIDEO_BASE_PATH + video.poster,
    sources: [
      { type: 'video/mp4', src: VIDEO_BASE_PATH + video.mp4 },
      { type: 'video/webm', src: VIDEO_BASE_PATH + video.webm }
    ]
  }
}
